import { checkMaintenance } from "./login/check-maintenance";
import { checkPassword } from "./login/check-password";
import { codeLogin } from "./login/code-login";

checkPassword();
checkMaintenance();
codeLogin();

// Fokus auf E-Mail setzen
document.forms.loginForm.elements.email.focus();

// Bei mobilen ansichten per Link mehr einblenden
$("#showLawInfo").click(() => {
	$("#showLawInfo").removeClass("visible-xs").removeClass("visible-sm").hide();
	$("#lawInfo")
		.hide()
		.removeClass("hidden-xs")
		.removeClass("hidden-sm")
		.show("500");

	return false;
});
